export interface DashboardFilters {
  startDate: string;
  endDate: string;
  company: string;
  roles: string[];
  saleChannels: string[];
  regions: string[];
  subRegion: string;
  goal: string;
  period: string;
  plans: string[];
  relationship: string[];
  fieldType: string;
}

export const ACTIONS = {
  START_DATE: 'START_DATE',
  END_DATE: 'END_DATE',
  COMPANY: 'COMPANY',
  ROLES: 'ROLES',
  SALE_CHANNELS: 'SALE_CHANNELS',
  REGIONS: 'REGIONS',
  SUB_REGION: 'SUB_REGION',
  GOAL: 'GOAL',
  PERIOD: 'PERIOD',
  PLANS: 'PLANS',
  RELATIONSHIP: 'RELATIONSHIP',
  FIELD_TYPE: 'FIELD_TYPE',
  TOTAL_POINTS_BALANCE: 'TOTAL_POINTS_BALANCE',
  TOTAL_PONITS_ASSIGNED: 'TOTAL_PONITS_ASSIGNED',
  TOTAL_PONITS_REDEEMED: 'TOTAL_PONITS_REDEEMED',
} as const;

export type DashboardFiltersActionType =
  | { type: typeof ACTIONS.START_DATE; payload: string }
  | { type: typeof ACTIONS.END_DATE; payload: string }
  | { type: typeof ACTIONS.COMPANY; payload: string }
  | { type: typeof ACTIONS.ROLES; payload: string[] }
  | { type: typeof ACTIONS.SALE_CHANNELS; payload: string[] }
  | { type: typeof ACTIONS.REGIONS; payload: string[] }
  | { type: typeof ACTIONS.SUB_REGION; payload: string }
  | { type: typeof ACTIONS.GOAL; payload: string }
  | { type: typeof ACTIONS.PLANS; payload: string[] }
  | { type: typeof ACTIONS.FIELD_TYPE; payload: string }
  | { type: typeof ACTIONS.RELATIONSHIP; payload: string[] }
  | { type: typeof ACTIONS.PERIOD; payload: string };

export function dashboardFiltersReducer(
  state: Partial<DashboardFilters>,
  action: DashboardFiltersActionType
): Partial<DashboardFilters> {
  switch (action.type) {
    case ACTIONS.START_DATE:
      return { ...state, startDate: action.payload };
    case ACTIONS.END_DATE:
      return { ...state, endDate: action.payload };
    case ACTIONS.COMPANY:
      return { ...state, company: action.payload };
    case ACTIONS.ROLES:
      return { ...state, roles: action.payload };
    case ACTIONS.SALE_CHANNELS:
      return { ...state, saleChannels: action.payload };
    case ACTIONS.REGIONS:
      return { ...state, regions: action.payload };
    case ACTIONS.SUB_REGION:
      return { ...state, subRegion: action.payload };
    case ACTIONS.GOAL:
      return { ...state, goal: action.payload };
    case ACTIONS.PERIOD:
      return { ...state, period: action.payload };
    case ACTIONS.PLANS:
      return { ...state, plans: action.payload };
    case ACTIONS.RELATIONSHIP:
      return { ...state, relationship: action.payload };
    case ACTIONS.FIELD_TYPE:
      return { ...state, fieldType: action.payload };
    default:
      return state;
  }
}
